import { style } from "dom-helpers";
import React from "react";
import { Input } from "./Input";
import { LbSelect } from "./LbSelect";

export const Phone = ({
  isLoading = false,
  error = false,
  phoneOptions,
  placeholder = "",
  label = "",
  name = "",
  value = "",
  prefixValue = undefined,
  onChange = () => {},
  onBlur = () => {},
  onPrefixChange = () => {},
}) => {
  return (
    <div className="form-group__mobile-number">
      {/* <LbSelect
        disabled
        options={phoneOptions}
        isLoading={isLoading}
        // label={i18n.t("Application.Pos.phonePrefixes")}
        value={prefixValue}
        onChange={onPrefixChange}
        // onBlur={formik.handleBlur("phonePrefixes")}
        // menuIsOpen={true}
      /> */}
      {/* <span> +995 </span> */}
      <Input
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        regex="^[0-9]+$"
        maxLength={9}
        placeholder={placeholder}
      />
    </div>
  );
};
